/**
 * Facade for YouTube/Vimeo iframes in product description and accordion content.
 * Replaces direct iframes with a poster + play button; loads the embed only on click
 * to save network and TBT.
 */
(function () {
  const SELECTORS = [
    '.product__description',
    '.accordion__content',
    '.product-popup-modal__content-info',
    '.description__content',
  ].join(', ');

  function getVideoId(iframe) {
    const src = iframe.getAttribute('src') || '';
    let id = null;
    if (src.includes('youtube.com/embed/') || src.includes('youtube-nocookie.com/embed/')) {
      const m = src.match(/embed\/([^?&]+)/);
      id = m ? m[1] : null;
    } else if (src.includes('youtu.be/')) {
      const m = src.match(/youtu\.be\/([^?&]+)/);
      id = m ? m[1] : null;
    } else if (src.includes('vimeo.com/video/')) {
      const m = src.match(/vimeo\.com\/video\/(\d+)/);
      id = m ? m[1] : null;
    }
    return { id, isVimeo: src.includes('vimeo') };
  }

  function addAutoplayToSrc(src) {
    if (!src) return src;
    const hasParams = src.includes('?');
    const separator = hasParams ? '&' : '?';
    if (src.includes('autoplay=')) return src;
    return src + separator + 'autoplay=1';
  }

  function getPosterUrl(videoId, isVimeo) {
    if (isVimeo) return null;
    if (videoId && videoId.id) {
      return `https://img.youtube.com/vi/${videoId.id}/hqdefault.jpg`;
    }
    return null;
  }

  function createFacade(iframe) {
    const { id, isVimeo } = getVideoId(iframe);
    const src = iframe.getAttribute('src') || '';
    const width = iframe.getAttribute('width') || '560';
    const height = iframe.getAttribute('height') || '315';

    const wrapper = document.createElement('div');
    wrapper.className = 'youtube-facade';
    wrapper.setAttribute('data-facade-loaded', 'false');
    wrapper.style.position = 'relative';
    wrapper.style.aspectRatio = `${width} / ${height}`;
    wrapper.style.width = '100%';
    wrapper.style.overflow = 'hidden';
    wrapper.style.borderRadius = 'var(--media-radius, 0)';

    const posterUrl = getPosterUrl({ id }, isVimeo);
    const poster = document.createElement('button');
    poster.type = 'button';
    poster.className = 'youtube-facade__poster';
    poster.setAttribute('aria-label', 'Play video');
    poster.style.cssText =
      'position:absolute;inset:0;width:100%;height:100%;border:none;padding:0;margin:0;cursor:pointer;display:flex;align-items:center;justify-content:center;background:#000;';

    if (posterUrl) {
      const img = document.createElement('img');
      img.src = posterUrl;
      img.alt = '';
      img.loading = 'lazy';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
      poster.appendChild(img);
    }

    const playBtn = document.createElement('span');
    playBtn.className = 'youtube-facade__play motion-reduce';
    playBtn.innerHTML = `<svg class="icon icon-play" width="56" height="56" viewBox="0 0 18 24" fill="none" aria-hidden="true"><path fill="currentColor" d="M18 12L0 24V0l18 12Z"/></svg>`;
    playBtn.style.cssText =
      'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:48px;height:48px;color:white;filter:drop-shadow(0 2px 8px rgba(0,0,0,0.5));';
    poster.appendChild(playBtn);

    poster.addEventListener('click', function () {
      if (wrapper.getAttribute('data-facade-loaded') === 'true') return;
      wrapper.setAttribute('data-facade-loaded', 'true');
      poster.remove();
      const newIframe = document.createElement('iframe');
      newIframe.src = addAutoplayToSrc(src);
      newIframe.width = width;
      newIframe.height = height;
      newIframe.frameBorder = '0';
      newIframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      newIframe.allowFullscreen = true;
      newIframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;';
      newIframe.classList.add(isVimeo ? 'js-vimeo' : 'js-youtube');
      wrapper.appendChild(newIframe);
      if (window.pauseAllMedia) window.pauseAllMedia();
    });

    wrapper.appendChild(poster);
    return wrapper;
  }

  function init() {
    const containers = document.querySelectorAll(SELECTORS);
    containers.forEach((container) => {
      const iframes = container.querySelectorAll(
        'iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="vimeo.com"]',
      );
      iframes.forEach((iframe) => {
        if (iframe.closest('.youtube-facade')) return;
        const facade = createFacade(iframe);
        iframe.parentNode.replaceChild(facade, iframe);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
